import React from 'react';
import { Button } from 'reactstrap';
import { ModalButtonSave, ModalButtonUpdate, } from '../../constant';
import { FormSpecimenProvenances } from './FormSpecimenProvenances';
import { Dialog } from 'primereact/dialog';

export const ModalSpecimenProvenances = (props) => {

    const {
        modal, modalTitle, closeDialog, method, loading,
        name, abbreviation, handleInputChange,
        validaciones, saveCreate, saveUpdate, saveDelete
    } = props;

    const footer = (
        <div className='mt-2' style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>



            <Button
                color="secondary"
                size="sm"
                onClick={method === "create" ? saveCreate : saveUpdate}
                className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
            >
                Confirmar
            </Button>

            <Button
                color="danger"
                size="sm"
                onClick={closeDialog}
            >
                Cancelar
            </Button>

        </div>
    );


    return (
        <Dialog
            visible={modal}
            onHide={closeDialog}
            closable={false}
            modal
            blockScroll
            footer={footer}
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">

                        <div className="Global-dialog-icon">
                            <i className="fa fa-cubes f-20"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle}
                            </div>


                        </div>

                    </div>
                </div>
            }
            draggable={false}

            className={`Global-dialog Global-dialog Global-blue Global-small-v`}


        >
            {
                method === "create"
                    ?
                    <FormSpecimenProvenances
                        button={ModalButtonSave}
                        {...{ loading, handleInputChange, validaciones, methodAction: saveCreate }}
                    />
                    :
                    (method === "update")
                        ?
                        <FormSpecimenProvenances
                            button={ModalButtonUpdate}
                            {...{ loading, handleInputChange, validaciones, methodAction: saveUpdate, name, abbreviation }}
                        />
                        :
                        null
            }
        </Dialog>
    )
}
